// DocumentStatus.js
import classes from "./AuditTrailVertical.module.css";
import { PiCopyLight } from "react-icons/pi";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import CreateIcon from "../../icons/CreateIcon";
import DocumentIcon from "../../icons/DocumentIcon";
import DisposedIcon from "../../icons/DisposedIcon";
import UserPortraitIcon from "../../icons/UserPortraitIcon";
import { env } from "../../constants/env";

// const timelineData = [
//   {
//     status: "completed",
//     icon: <CreateIcon />,
//     action: "Created",
//     date: "12.05.24 - 12:00 PM",
//     user: "John Marston",
//   },
//   {
//     status: "completed",
//     icon: <UserPortraitIcon />,
//     action: "Submitted for approval",
//     date: "12.05.24 - 15:00 PM",
//     user: "Michael Hutchins",
//   },
//   {
//     status: "rejected",
//     icon: <DocumentIcon />,
//     action: "Rejected",
//     date: "12.05.24 - 18:00 PM",
//     user: "Michael Hutchins",
//     badge: "View",
//   },
//   {
//     status: "current",
//     icon: <UserPortraitIcon />,
//     action: "Submitted for approval",
//     date: "12.05.24 - 15:00 PM",
//     user: "Michael Hutchins",
//   },
//   {
//     status: "pending",
//     icon: <ApprovedIcon />,
//     action: "Approved",
//     statusNote: "Pending",
//   },
//   {
//     status: "pending",
//     icon: <DisposedIcon />,
//     action: "Disposed",
//     statusNote: "Pending",
//   },
// ];

const iconMap = {
  CreateIcon: <CreateIcon />,
  DocumentIcon: <DocumentIcon />,
  PendingIcon: <DisposedIcon />,
  DefaultIcon: <UserPortraitIcon />,
};

// const metaTags = [
//   { content: "#1219295591", icon: <PiCopyLight size={15} /> },
//   { content: "Status Rejected" },
//   { content: "Assigned Michael Hutchins" },
//   { content: "Urgency Not set" },
//   { content: "Approval Not set" },
//   { content: "Disposal Not set" },
//   { content: "Template Document template name" },
// ];

const AuditTrailVertical = () => {
  const navigate = useNavigate();
  const { submitId } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeline, setTimeline] = useState([]);

  const lastStep = timeline[timeline.length - 1];

  let metaTags = [];

  if (lastStep) {
    metaTags = [
      formData?.form?.tags?.[1] && {
        content: `#${formData.form.tags[1]}`,
        icon: <PiCopyLight size={15} />,
      },
      lastStep.status && {
        content: `Status ${capitalizeFirst(lastStep.status)}`,
      },
      lastStep.user && {
        content: `Assigned ${lastStep.user}`,
      },
    ].filter((tag) => tag !== null && tag !== undefined);
  }

  function capitalizeFirst(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    if (submitId) {
      axios
        .get(`${env.apiUrl}/api/submissions/${submitId}`)
        .then((response) => {
          setFormData(response.data);
          setLoading(false);
          console.log("Fetched document:", response.data);
        })
        .catch((error) => {
          console.error("Error fetching document:", error);
          setLoading(false);
        });
    }
  }, [submitId]);

  useEffect(() => {
    const fetchTimeline = async () => {
      try {
        const response = await fetch(
          `${env.apiUrl}/api/audit-trail/${submitId}`
        );
        const data = await response.json();

        const formatted = data.map((item) => ({
          ...item,
          icon: iconMap[item.icon] || <DisposedIcon />,
        }));

        setTimeline(formatted);
      } catch (error) {
        console.error("Error fetching timeline:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeline();
  }, []);

  if (loading) return <div>Loading...</div>;
  return (
    <div className={classes.wrapper}>
      <div className={classes.verticalTimeline}>
        {timeline.map((item, idx) => (
          <div
            key={idx}
            className={`${classes.timelineItem} ${classes[item.status]}`}
          >
            <div className={classes.timelineDotContainer}>
              <div className={classes.timelineDot}></div>
            </div>
            <div className={classes.timelineCard}>
              {item.icon}
              <div className={classes.timelineContent}>
                <div className={classes.timelineAction}>{item.action}</div>
                {item.date && (
                  <div className={classes.timelineDate}>{item.date}</div>
                )}
                {item.user && (
                  <div className={classes.timelineUser}>
                    {item.user}
                    {item.badge && (
                      <span className={classes.viewBadge}>{item.badge}</span>
                    )}
                  </div>
                )}
                {item.statusNote && (
                  <div className={classes.timelineStatus}>
                    {item.statusNote}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditTrailVertical;
